import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { AppRouter } from "./Routes";
import { Toaster } from "react-hot-toast";
import InstallPWA from "./InstallPWA";
import TawkToIntegration from "./components/Tawkto/Tawkto";
import useDocumentTitle from "./hooks/useDocumentTitle";

function App() {
  const productType = process.env.REACT_APP_PRODUCT_TYPE;

  useDocumentTitle(`${productType} App`);

  return (
    <div className="max-w-[1600px] mx-auto">
      <BrowserRouter>
        <TawkToIntegration />
        <Toaster />
        <AppRouter />
        <InstallPWA />
      </BrowserRouter>
    </div>
  );
}

export default App;
